import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMobileMenuOpen(false);
        }
    };

    return (
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
            <div className="navbar-container container">
                <div className="navbar-logo">
                    <img src="/sa-logo-removebg-preview.png" alt="SA Visa Consultants Logo" className="logo-image" />
                </div>

                <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                    <a href="#home" onClick={() => scrollToSection('home')} className="nav-link">
                        Home
                    </a>
                    <a href="#about" onClick={() => scrollToSection('about')} className="nav-link">
                        About
                    </a>
                    <a href="#services" onClick={() => scrollToSection('services')} className="nav-link">
                        Services
                    </a>
                    <a href="#team" onClick={() => scrollToSection('team')} className="nav-link">
                        Team
                    </a>
                    <a href="#destinations" onClick={() => scrollToSection('destinations')} className="nav-link">
                        Destinations
                    </a>

                    <div className="navbar-contact-mobile">
                        <a href="tel:+96895249020" className="contact-link">
                            <FaPhone /> +968 95249020
                        </a>
                        <a href="mailto:savisaconsultant080@gmail.com" className="contact-link">
                            <FaEnvelope /> Email Us
                        </a>
                    </div>
                </div>

                <div className="navbar-actions">
                    <button
                        className="btn btn-primary navbar-btn"
                        onClick={() => scrollToSection('contact')}
                    >
                        Get Started
                    </button>
                </div>

                <button
                    className="mobile-menu-toggle"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
